import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFillRatio = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_3004_29356",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 100,
		height: 100,
		children: /* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 99,
			height: 99,
			fill: "#C4C4C4",
			stroke: "#9EA9B9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_3004_29356)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M90.8558 33.3136L64.7462 19.1789L14.8143 47.3503L40.9239 61.4851L90.8558 33.3136Z",
				fill: "#FDF1E6",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M90.6377 68.0421L90.6382 50.0855L40.9198 78.0672L40.9193 96.0238L90.6377 68.0421Z",
				fill: "#FDF1E6",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40.9208 78.0674L14.6627 63.852L14.6619 81.8811L40.9201 96.0964L40.9208 78.0674Z",
				fill: "#FDF1E6",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M77.7624 26.6311L77.7628 8.67449L43.5888 28.0427L43.5884 45.9993L77.7624 26.6311Z",
				fill: "#F6DCC4",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M75.0925 42.5242L75.0929 24.5676L40.9189 43.9358L40.9185 61.8924L75.0925 42.5242Z",
				fill: "#F6DCC4",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40.9208 61.4848L14.6627 47.2695L14.6619 65.2986L40.9201 79.5139L40.9208 61.4848Z",
				fill: "#FDF1E6",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40.9208 43.9355L14.6627 29.7202L14.6619 47.7493L40.9201 61.9646L40.9208 43.9355Z",
				fill: "#F6DCC4",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M90.6377 51.4601L90.6382 33.5035L40.9198 61.4852L40.9193 79.4418L90.6377 51.4601Z",
				fill: "#FDF1E6",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M64.7454 1.62885L14.8135 29.8003L40.9231 43.9351L75.0926 24.541L63.4568 17.1364L77.8002 8.69622L64.7454 1.62885Z",
				fill: "#F6DCC4",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M43.3003 25.2378C42.4767 25.2378 41.8038 24.9627 41.2815 24.4124C40.7592 23.8622 40.498 23.1056 40.498 22.1426C40.498 21.4971 40.6186 20.9415 40.8596 20.4759C41.1007 20.0103 41.4321 19.6558 41.854 19.4124C42.2859 19.1691 42.768 19.0474 43.3003 19.0474C43.8326 19.0474 44.3097 19.1691 44.7316 19.4124C45.1635 19.6558 45.4999 20.0103 45.741 20.4759C45.982 20.9415 46.1026 21.4971 46.1026 22.1426C46.1026 23.1056 45.8414 23.8622 45.3191 24.4124C44.7969 24.9627 44.1239 25.2378 43.3003 25.2378ZM49.4924 19.2061H52.0385L44.837 30.3172H42.2909L49.4924 19.2061ZM43.3003 23.5236C43.4911 23.5236 43.6468 23.4177 43.7674 23.2061C43.8979 22.9839 43.9632 22.6294 43.9632 22.1426C43.9632 21.6558 43.8979 21.3066 43.7674 21.095C43.6468 20.8728 43.4911 20.7616 43.3003 20.7616C43.1095 20.7616 42.9488 20.8728 42.8182 21.095C42.6977 21.3066 42.6374 21.6558 42.6374 22.1426C42.6374 22.6294 42.6977 22.9839 42.8182 23.2061C42.9488 23.4177 43.1095 23.5236 43.3003 23.5236ZM51.0291 30.4759C50.2055 30.4759 49.5326 30.2008 49.0103 29.6505C48.488 29.1003 48.2269 28.3437 48.2269 27.3807C48.2269 26.7352 48.3474 26.1796 48.5884 25.714C48.8295 25.2484 49.1609 24.8939 49.5828 24.6505C50.0147 24.4072 50.4968 24.2855 51.0291 24.2855C51.5615 24.2855 52.0385 24.4072 52.4604 24.6505C52.8923 24.8939 53.2287 25.2484 53.4698 25.714C53.7109 26.1796 53.8314 26.7352 53.8314 27.3807C53.8314 28.3437 53.5702 29.1003 53.048 29.6505C52.5257 30.2008 51.8527 30.4759 51.0291 30.4759ZM51.0291 28.7616C51.22 28.7616 51.3756 28.6558 51.4962 28.4442C51.6267 28.222 51.692 27.8675 51.692 27.3807C51.692 26.8939 51.6267 26.5447 51.4962 26.3331C51.3756 26.1109 51.22 25.9997 51.0291 25.9997C50.8383 25.9997 50.6776 26.1109 50.547 26.3331C50.4265 26.5447 50.3662 26.8939 50.3662 27.3807C50.3662 27.8675 50.4265 28.222 50.547 28.4442C50.6776 28.6558 50.8383 28.7616 51.0291 28.7616Z",
				fill: "white"
			})
		]
	})]
});
export default SvgFillRatio;
